import React from 'react';
import api from 'api';
import { Spinner, Modal } from 'hyperdb-utils';
import GlobalSettings from './GlobalSettings';
import InventorySettings from './InventorySettings';
import EmailSettings from './EmailSettings';

class Wizard extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      _init: false,
    }
  }
  componentDidMount() {
    this.props.api.wizard.setData({
      wizardStep: 'global-settings',
      data: {
        vatPercent: 10,
        currency: 'EUR',
        propertyGroup: { name: 'Default', description: 'default group' },
        checkInOutRuleset: {
          name: 'Default',
          min_check_in_time: '12:00',
          max_check_in_time: '00:00',
          min_check_out_time: '08:00',
          max_check_out_time: '12:00',
        },
        cancellationPolicy: { name: 'Default', cancellation_fees: [] },
        smtpSettings: {},
        imapSettings: {},
        signature: '{{ sender.display_name }}',
      },
    })
    .then(() => this.setState({ _init: true }));
  }
  render() {
    const { wizardStep, loading } = this.getProps();
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row">
            <div className="col-md-11">
              <span className="btn btn-sm btn-primary" onClick={ this.handleClickBack } disabled={ wizardStep === 'global-settings' }>
                <i className="fas fa-chevron-left"></i> Back
              </span>
              &nbsp;<h3 className="box-title">{ this.pageTitle() }</h3>
            </div>
            <div className="col-md-1">
              {
                wizardStep !== 'email-settings'
                  ? <button type="button" className="btn btn-sm btn-primary" onClick={ this.handleClickNext } disabled={ !this.stepValid() }>
                      Next <i className="fas fa-chevron-right" />
                    </button>
                  : <button type="button" className="btn btn-sm btn-success" onClick={ this.toggleModalSubmit.bind(this, true) }>
                      Finish
                    </button>
              }
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          <div className="box box-primary">
            <Spinner show={ loading } />
            <div className="box-body hyperdb-form">
              <form role="form" className="hyperdb-form">
                { this.renderForm() }
              </form>
            </div>
          </div>
        </section>
        {
          this.props.showModalSubmit
            ? <Modal title="Finish wizard" onClose={ this.toggleModalSubmit.bind(this, false) } onAccept={ this.handleSubmit }>
                Are you sure you want to validate the itnitialization wizard ?
              </Modal>
            : null
        }
      </div>
    );
  }

  getProps() {
    return this.props.api.getState('wizard') || {};
  }
  renderForm() {
    if (!this.state._init) return null;
    const props = this.getProps();
    let Component;
    switch (props.wizardStep) {
    case 'global-settings':
      Component = GlobalSettings;
      break;
    case 'inventory-settings':
      Component = InventorySettings;
      break;
    case 'email-settings':
      Component = EmailSettings;
      break;
    }
    if (!Component) return null;
    return <Component { ...props.data } onChange={ this.handleChange } api={ this.props.api} />;
  }
  handleChange(attributeName, value) {
    const data = this.getProps().data;
    data[attributeName] = value;
    this.props.api.wizard.setData({ data });
  }
  pageTitle() {
    const props = this.getProps();
    switch (props.wizardStep) {
    case 'global-settings':
      return 'Global settings';
    case 'inventory-settings':
      return 'Inventory settings'
    case 'email-settings':
      return 'Email account settings';
    default:
      return '';
    }
  }
  stepValid() {
    const props = this.getProps();
    switch (props.wizardStep) {
    case 'global-settings':
      return !!props.data.currency;
    case 'inventory-settings':
      return !!props.data.propertyGroup.name && !!props.data.checkInOutRuleset.name && props.data.cancellationPolicy.name;
    case 'email-settings':
      return true;
    default:
      return false;
    }
  }

  handleClickBack() {
    const props = this.getProps();
    let wizardStep = 'global-settings';
    switch (props.wizardStep) {
    case 'inventory-settings':
      wizardStep = 'global-settings';
      break;
    case 'email-settings':
      wizardStep = 'inventory-settings';
      break;
    }
    this.props.api.wizard.setData({ wizardStep });
  }
  handleClickNext() {
    const props = this.getProps();
    let wizardStep = 'email-settings';
    switch (props.wizardStep) {
    case 'global-settings':
      wizardStep = 'inventory-settings';
      break;
    case 'inventory-settings':
      wizardStep = 'email-settings';
      break;
    }
    this.props.api.wizard.setData({ wizardStep });
  }

  toggleModalSubmit(bool) {
    this.props.api.wizard.setData({ showModalSubmit: bool });
  }
  handleSubmit() {
    this.props.api.wizard.postData({ url: '/', data: this.props.data })
      .then(() => {
        this.props.api.wizard.setData({ showModalSubmit: false });
      });
  }
}

export default api.connect(Wizard, 'wizard');



// WEBPACK FOOTER //
// ./src/frontend/init-wizard/Wizard.jsx